/* eslint-disable react/require-default-props */
import { Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Rating.scss';

type RatingProps = {
  rating: string;
  size?: string;
  open?: boolean;
  handleTooltipParent?: (string: string) => void;
};

const Rating = ({ rating, size = '', open = false, handleTooltipParent }: RatingProps) => {
  const [t] = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState('');
  const handleTooltip = (rate: string) => {
    setTooltipOpen(rate);
  };
  const getTooltip = () => {
    if (rating === '5') return t('5');
    if (rating === '4') return t('4');
    if (rating === '3') return t('3');
    if (rating === '2') return t('2');
    if (rating === '1') return t('1');
    if (rating === '0') return t('0');
    if (rating === 'S') return t('S');
    return '';
  };

  // useEffect(() => {
  //   if (tooltipOpen === (rating as string) && open && handleTooltipParent) handleTooltipParent('');
  // }, [handleTooltipParent, tooltipOpen]);
  return (
    <Tooltip
      title={getTooltip() as string}
      key={`${rating as string}`}
      open={tooltipOpen === (rating as string) && open}
      placement="top"
      PopperProps={{ style: { pointerEvents: 'none', marginTop: '30px', zIndex: 1564 } }}
    >
      <span
        onMouseEnter={() => {
          handleTooltip(rating as string);
        }}
        onMouseLeave={() => {
          handleTooltip('');
        }}
        onMouseOut={() => {
          handleTooltip('');
        }}
        onBlur={() => handleTooltip('')}
        className="tooltip-container"
      >
        <span className={`rate-container ${size}`}>
          <div translate="no" className={`rate ${rating} ${size}`}>
            {rating !== 'S' ? rating : 'Skip'}
          </div>
        </span>
      </span>
    </Tooltip>
  );
};

export default Rating;
